<div class="filter">
  <div *ngIf="filterStatuses" class="filter__item">
    <app-filter-select [filterTitle]="'statuses'" [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div *ngIf="filterRecPaymentPeriodTypes" class="filter__item">
    <app-filter-select
      [filterTitle]="'recPaymentPeriodTypes'"
      [filter]="filterRecPaymentPeriodTypes"
    >
    </app-filter-select>
  </div>
  <div *ngIf="filterNotifications" class="filter__item">
    <app-filter-select
      [filterTitle]="'notifications'"
      [filter]="filterNotifications"
    >
    </app-filter-select>
  </div>
  <div class="filter__item">
    <app-amount-range
      [filterSumFrom]="filterSumFrom"
      [filterSumTo]="filterSumTo"
      title="{{ 'FILTERS.SUM' | translate }}"
    >
    </app-amount-range>
  </div>
  <div *ngIf="filterCurrencies" class="filter__item">
    <app-filter-select [filterTitle]="'currencies'" [filter]="filterCurrencies">
    </app-filter-select>
  </div>
  <div class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{ 'FILTERS.NEXT_PERIOD' | translate }}"
    >
    </app-period>
  </div>
</div>
